import styles from './sentryFallback.styl';

export default function SentryFallback() {
  return (
    <div className={styles.sentry}>
      <div className={styles.title}>Что-то пошло не так</div>
      <div className={styles.subtitle}>Мы уже знаем об этом и скоро всё исправим</div>
      <a href='/' className={styles.link}>
        <button className={styles.btn}>Перейти на главную</button>
      </a>
    </div>
  );
}
